import { useAuth } from "../../../context";
import { useMutation, useQuery } from "react-query";
import { SupplierAdministration } from "../../../api";

export const supplierAdministrationKeys = {
  all: () => ["suppliersUsers"],
  paginatedSuppliersWithTiers: () => ["paginatedSuppliersWithTiers"],
  supplierLocations: () => ["supplierLocations"],
  supplierCountWithCompletedQuestionnaire: () => ["supplierCountWithCompletedQuestionnaire"]
};

export function useGetSupplierUsers(paramsString, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierAdministrationKeys.all(), paramsString],
    () => callApi(SupplierAdministration.getSupplierUsers, paramsString), config);
}

export function useCreateSupplierUser(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(SupplierAdministration.createSupplierUser, data), config);
}

export function useUpdateSupplierUser(config) {
  const { callApi } = useAuth();
  return useMutation(({ id, data }) => callApi(SupplierAdministration.updateSupplierUser, { id, data }), config);
}

export function useResendSupplierInvitation(config) {
  const { callApi } = useAuth();
  return useMutation(id => callApi(SupplierAdministration.resendSupplierInvitation, id), config);
}

export function useActivateUser(config) {
  const { callApi } = useAuth();
  return useMutation(id => callApi(SupplierAdministration.activateUser, id), config);
}

export function useDeactivateUser(config) {
  const { callApi } = useAuth();
  return useMutation(id => callApi(SupplierAdministration.deactivateUser, id), config);
}

export function useGetPaginatedSuppliersWithTiers(paramsString, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierAdministrationKeys.paginatedSuppliersWithTiers(), paramsString],
    () => callApi(SupplierAdministration.getPaginatedSuppliersWithTiers, paramsString), config);
}

export function useSupplierCountWithCompletedQuestionnaire(paramsString, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierAdministrationKeys.supplierCountWithCompletedQuestionnaire(), paramsString],
    () => callApi(SupplierAdministration.getSupplierCountWithCompletedQuestionnaire, paramsString), config);
}

export function useManageSupplierCompany(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(SupplierAdministration.manageSupplierCompany, data), config);
}

export function useManageSupplierStatus(config) {
  const { callApi } = useAuth();
  return useMutation(({ id, status }) => callApi(SupplierAdministration.manageSupplierStatus, { id, status }), config);
}

export function useGetSupplierLocations(paramsString, config) {
  const { callApi } = useAuth();
  return useQuery([...supplierAdministrationKeys.supplierLocations(), paramsString],
    () => callApi(SupplierAdministration.getSupplierLocations, paramsString), config);
}

export function useCreateSupplierLocation(config) {
  const { callApi } = useAuth();
  return useMutation(data => callApi(SupplierAdministration.createSupplierLocation, data), config);
}

export function useUpdateSupplierLocation(config) {
  const { callApi } = useAuth();
  return useMutation(({ id, data }) => callApi(SupplierAdministration.updateSupplierLocation, { id, data }), config);
}

export function useDeleteSupplierLocation(config) {
  const { callApi } = useAuth();
  return useMutation(id => callApi(SupplierAdministration.deleteSupplierLocation, id), config);
}

export function useDownloadSupplierLocationsTemplate(config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(SupplierAdministration.downloadSupplierLocationsTemplate), config);
}

export function useImportSupplierLocations(config) {
  const { callApi } = useAuth();
  return useMutation(({ data }) => callApi(SupplierAdministration.importSupplierLocations, { data }), config);
}

export function useExportSupplierCompanies(config) {
  const { callApi } = useAuth();
  return useMutation(() => callApi(SupplierAdministration.exportSupplierCompanies), config);
}